import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './main/landing/landing.component';
import { RedirectResolver } from '../services/redirect.resolver';


const routes: Routes = [
  {
    path : '',
    component : LandingComponent,
    resolve : {
        lang: RedirectResolver,
    },
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
    imports : [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', initialNavigation: 'enabledBlocking' })],
    exports : [RouterModule],
})
export class AppRoutingModule {
}
